import { environment } from "src/environments/environment";
import { OktaUserModel } from "@engie-group/ngx-gem-spaas";

export class UserData extends OktaUserModel{
    public IsTrader: boolean = false;
    public HasFHCAccess: boolean = false;
    public HasMorayEastAccess: boolean = false;
    public HasMorayWestAccess: boolean = true;
    public HasRetailAccess: boolean = false;
    public HasResAccess: boolean = true; 
    public IsReadOnly: boolean = true;
    public CanArchive: boolean = false;

    constructor(oktaInfo: OktaUserModel) {
        super(oktaInfo);
        this.IsTrader = this.checkGroup(environment.groups.trader);
        this.HasFHCAccess = this.checkGroup(environment.groups.fhc);
        this.HasMorayEastAccess = this.checkGroup(environment.groups.moray_east);
        this.HasMorayWestAccess = this.checkGroup(environment.groups.moray_west);
        this.HasRetailAccess = this.checkGroup(environment.groups.retail);
        this.HasResAccess = this.checkGroup(environment.groups.res);
        this.IsReadOnly = this.checkGroup(environment.groups.readonly);
        this.CanArchive = this.checkGroup(environment.groups.archiver);
    }
}